export const regions = [
  { constituency: "Aberdeen Central", region: "North East Scotland" },
  { constituency: "Aberdeen Donside", region: "North East Scotland" },
  {
    constituency: "Aberdeen South and North Kincardine",
    region: "North East Scotland",
  },
  { constituency: "Aberdeenshire East", region: "North East Scotland" },
  { constituency: "Aberdeenshire West", region: "North East Scotland" },
  { constituency: "Airdrie and Shotts", region: "Central Scotland" },
  { constituency: "Almond Valley", region: "Lothian" },
  { constituency: "Angus North and Mearns", region: "North East Scotland" },
  { constituency: "Angus South", region: "North East Scotland" },
  { constituency: "Argyll and Bute", region: "Highlands and Islands" },
  { constituency: "Ayr", region: "South Scotland" },
  {
    constituency: "Banffshire and Buchan Coast",
    region: "North East Scotland",
  },
  {
    constituency: "Caithness, Sutherland and Ross",
    region: "Highlands and Islands",
  },
  {
    constituency: "Carrick, Cumnock and Doon Valley",
    region: "South Scotland",
  },
  {
    constituency: "Clackmannanshire and Dunblane",
    region: "Mid Scotland and Fife",
  },
  { constituency: "Clydebank and Milngavie", region: "West Scotland" },
  { constituency: "Clydesdale", region: "South Scotland" },
  { constituency: "Coatbridge and Chryston", region: "Central Scotland" },
  { constituency: "Cowdenbeath", region: "Mid Scotland and Fife" },
  { constituency: "Cumbernauld and Kilsyth", region: "Central Scotland" },
  { constituency: "Cunninghame North", region: "West Scotland" },
  { constituency: "Cunninghame South", region: "West Scotland" },
  { constituency: "Dumbarton", region: "West Scotland" },
  { constituency: "Dumfriesshire", region: "South Scotland" },
  { constituency: "Dundee City East", region: "North East Scotland" },
  { constituency: "Dundee City West", region: "North East Scotland" },
  { constituency: "Dunfermline", region: "Mid Scotland and Fife" },
  { constituency: "East Kilbride", region: "Central Scotland" },
  { constituency: "East Lothian", region: "South Scotland" },
  { constituency: "Eastwood", region: "West Scotland" },
  { constituency: "Edinburgh Central", region: "Lothian" },
  { constituency: "Edinburgh Eastern", region: "Lothian" },
  { constituency: "Edinburgh Northern and Leith", region: "Lothian" },
  { constituency: "Edinburgh Pentlands", region: "Lothian" },
  { constituency: "Edinburgh Southern", region: "Lothian" },
  { constituency: "Edinburgh Western", region: "Lothian" },
  {
    constituency: "Ettrick, Roxburgh and Berwickshire",
    region: "South Scotland",
  },
  { constituency: "Falkirk East", region: "Central Scotland" },
  { constituency: "Falkirk West", region: "Central Scotland" },
  { constituency: "Galloway and West Dumfries", region: "South Scotland" },
  { constituency: "Glasgow Anniesland", region: "Glasgow" },
  { constituency: "Glasgow Cathcart", region: "Glasgow" },
  { constituency: "Glasgow Kelvin", region: "Glasgow" },
  { constituency: "Glasgow Maryhill and Springburn", region: "Glasgow" },
  { constituency: "Glasgow Pollok", region: "Glasgow" },
  { constituency: "Glasgow Provan", region: "Glasgow" },
  { constituency: "Glasgow Shettleston", region: "Glasgow" },
  { constituency: "Glasgow Southside", region: "Glasgow" },
  { constituency: "Greenock and Inverclyde", region: "West Scotland" },
  {
    constituency: "Hamilton, Larkhall and Stonehouse",
    region: "Central Scotland",
  },
  { constituency: "Inverness and Nairn", region: "Highlands and Islands" },
  { constituency: "Kilmarnock and Irvine Valley", region: "South Scotland" },
  { constituency: "Kirkcaldy", region: "Mid Scotland and Fife" },
  { constituency: "Linlithgow", region: "Lothian" },
  { constituency: "Mid Fife and Glenrothes", region: "Mid Scotland and Fife" },
  { constituency: "Midlothian North and Musselburgh", region: "Lothian" },
  {
    constituency: "Midlothian South, Tweeddale and Lauderdale",
    region: "South Scotland",
  },
  { constituency: "Moray", region: "Highlands and Islands" },
  { constituency: "Motherwell and Wishaw", region: "Central Scotland" },
  { constituency: "Na h-Eileanan an Iar", region: "Highlands and Islands" },
  { constituency: "North East Fife", region: "Mid Scotland and Fife" },
  { constituency: "Orkney", region: "Highlands and Islands" },
  { constituency: "Paisley", region: "West Scotland" },
  { constituency: "Perthshire North", region: "Mid Scotland and Fife" },
  {
    constituency: "Perthshire South and Kinross-shire",
    region: "Mid Scotland and Fife",
  },
  { constituency: "Renfrewshire North and West", region: "West Scotland" },
  { constituency: "Renfrewshire South", region: "West Scotland" },
  { constituency: "Rutherglen", region: "Glasgow" },
  { constituency: "Shetland", region: "Highlands and Islands" },
  {
    constituency: "Skye, Lochaber and Badenoch",
    region: "Highlands and Islands",
  },
  { constituency: "Stirling", region: "Mid Scotland and Fife" },
  { constituency: "Strathkelvin and Bearsden", region: "West Scotland" },
  { constituency: "Uddingston and Bellshill", region: "Central Scotland" },
];
